import React from 'react';
import PropTypes from 'prop-types';
import { playerWrapper } from 'cccisd-survey-common';

function Player(props) {
    return props.isPreview ? <span>Invisible date (this will be hidden when not in Preview mode)</span> : <span />;
}

Player.propTypes = {
    field: PropTypes.object.isRequired,
    isPreview: PropTypes.bool,
};

Player.defaultProps = {
    isPreview: false,
};

export default playerWrapper()(Player);
